// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminFulfillmentDocuments = (client) => ({
    /**
     * `POST /admin/fulfillment-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/admin/fulfillment-documents/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/fulfillment-documents", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/fulfillment-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/admin/fulfillment-documents/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/fulfillment-documents/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/fulfillment-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListFulfillmentDocuments
     * @source packages/medusa-plugin-fulfillment-documents/src/api/admin/fulfillment-documents/route.ts
     */
    list: (query, headers) => client.fetch("/admin/fulfillment-documents", { method: "GET", query, headers }),
    /**
     * `GET /admin/fulfillment-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/admin/fulfillment-documents/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/fulfillment-documents/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/fulfillment-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetFulfillmentDocumentSignedUrl
     * @source packages/medusa-plugin-fulfillment-documents/src/api/admin/fulfillment-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/admin/fulfillment-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=fulfillment-documents.js.map